"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.weaveIdea = weaveIdea;
const path = __importStar(require("path"));
const dist_1 = require("../../core/dist");
const dist_2 = require("../../core/dist");
const dist_3 = require("../../core/dist");
const thread_1 = require("./thread");
async function weaveIdea(input, deps) {
    const loomRoot = deps.getActiveLoomRoot();
    const weavesDir = path.join(loomRoot, 'loom');
    const weaveName = input.weave || (0, dist_1.toKebabCaseId)(input.title);
    const weavePath = path.join(weavesDir, weaveName);
    // Invariant: every doc lives in a thread; a weave folder contains only threads.
    // Weave-root idea creation is retired — a threadId is required.
    if (!input.threadId) {
        throw new Error('Cannot create an idea at weave root: every doc must live in a thread. Pass a threadId (create/select a thread first).');
    }
    const threadPath = path.join(weavePath, input.threadId);
    await deps.fs.ensureDir(threadPath);
    const id = (0, dist_1.generateDocId)('idea');
    const frontmatter = (0, dist_2.createBaseFrontmatter)('idea', id, input.title);
    const content = input.content ?? (0, dist_3.generateIdeaBody)(input.title);
    const doc = { ...frontmatter, content };
    const filePath = path.join(threadPath, (0, dist_1.singletonFileName)('idea'));
    await deps.saveDoc(doc, filePath);
    // Auto-scaffold the thread manifest (first-create seam) so the thread is on the roadmap.
    await (0, thread_1.ensureThreadManifest)(weaveName, input.threadId, input.title, deps);
    return { id, filePath };
}
